<template>
    <div class="home color-ffffff">
        <div class="pro-info">
            <div class="pro-bg" data-aos="fade-in">
            <div class="text-btm-right">ARTIST’S IMPRESSION</div>
            </div>
            <div class="text-content text-left color-f2ddc8" data-aos="fade-in">
                <p class="f3-5w light line-height-3-8w">MORE TO <br/>
                THE GOOD LIFE</p>
                <div class="f1-2w light">Welcome to a new home in revitalised Tengah that elevates 
                <div class="phone"></div>
                every standard of Executive Condominium living.</div>
            </div>
            <div class="home-more-btn color-f2ddc8 phone" @click="scrollTo869()"> 
            EXPLORE
            <img src="@/assets/btn/btm.png" alt=""></img>
            </div>
      </div>
      <div class="home-video flex flex-center h-100">
        <div class="position-relative video-container flex flex-center w80 h80 bg-000000">
            <iframe class="w100 h100" src="https://www.youtube.com/embed/0PHDK0kX-GA?si=DmfJYl-kLtjr7tRU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <!-- <img class="img-cover" src="@/assets/home/pro-bg.jpg" alt=""> -->
            <!-- <div class="position-absolute">
                <img class="w-3" src="@/assets/btn/video-play.png" alt="">
            </div>  -->
        </div>
      </div>
      <div class="home-introduce w100 h-60 flex flex-between bg-f2ddc8">
        <div class="w50 img-container2">
            <img class=" img-cover" data-aos="fade-in" src="@/assets/img/MRT_RGB_MR.jpg" alt="">
            <p>FOR ILLUSTRATION ONLY</p>
        </div>
        <div class="w50 h100 flex align-start" >
            <div class="w20 h80 line phone-m-t-20" data-aos="fade-in" data-aos-duration="1000"></div>
            <div class="w500 h100 flex flex-column align-start text-phone-h50 phone-m-t-20" style="margin-left: -2px;">
            <div class="text-left text-contents color-3e4037 h80 flex flex-column justify-end m-l-20" data-aos="fade-in" data-aos-delay="1000">
                <p class="f60 light ">
                    MORE 
                    <span class="phone"></span>
                    CONVENIENCE
                </p>
                <p class="f30 light">
                    WITH EVERYTHING YOU NEED 
                    AROUND YOU
                </p>
                <p class="f16 light p-t-b-3vh">
                    A home surrounded by possibilities with two future MRT stations, 
                    prestigious schools and future business districts only minutes away. 
                    All in the prime Tengah neighbourhood.
                </p>

            </div>
            <button class="home-introduce-btn" data-aos="fade-in" data-aos-duration="1000" @click="goPage('/location')">VIEW NEIGHBOURHOOD</button>
            </div>
        </div>
      </div>
      <div class="home-introduce row-reverse w100  flex flex-between align-center bg-3e4037 ov-none">
        <div class="w50 h-60 img-container2">
            <img class="img-cover" data-aos="fade-in" data-aos-delay="500" src="@/assets/gallery/Hydrotherapy_Pool_Gourmet_Dining_Lounge_RGB_MR.jpg" alt="">
            <p>ARTIST’S IMPRESSION</p>
        </div>

        <div class="w50 h-60 flex flex-center ov-none">
            <div class="w100 h60 flex flex-column align-start justify-end position-relative ">
                <div class="m-l-10s line1 w500 h-60 position-absolute phone-m-t-20" data-aos="fade-in" data-aos-duration="1000"></div>
                <div class="m-l-10s w500 p10 text-left position-absolute w100 h100 flex flex-column justify-end phone-m-t-20" data-aos="fade-in" data-aos-delay="1000">
                    <p class="f60 extra-light">
                        MORE 
                        <span class="phone"></span>
                        DISCOVERIES
                    </p>
                    <p class="f30 extra-light">
                        ACROSS EIGHT EXCEPTIONAL 
                        LANDSCAPE ZONES
                    </p>
                    <p class="f16 light p-t-b-3vh">
                        Where five pools and sprawling multi-sport courts turn 
                        every day into a private resort experience.
                    </p>

                </div>
             <button @click="goPage('/facilities')" class="m-l-10s home-introduce-btn" style="position: absolute;bottom: -35px;" data-aos="fade-in" data-aos-duration="1000">VIEW FACILITIES</button>
            </div>
        </div>

      </div>
      <div class="home-introduce w100 h-60 flex flex-between bg-f2ddc8">
        <div class="w50 img-container2">
            <img class=" img-cover" data-aos="fade-in" src="@/assets/interior/Hoi-Hup-Otto-Place- 03.jpg" alt="">
            <p>FOR ILLUSTRATION ONLY</p>
        </div>
        <div class="w50 h100 flex ov-none align-start">
            <div class="w20 h80 line phone-m-t-20"></div>
            <div class="w500 h100 flex flex-column align-start phone-m-t-20" style="margin-left: -2px;">
            <div class="text-left text-contents color-3e4037 h80 flex flex-column justify-end m-l-20" style="" data-aos="fade-in" data-aos-delay="1000">
                <p class="f60 light">
                    MORE 
                    <span class="phone"></span>
                    LUXURY
                </p>
                <p class="f30 light">
                BUILT INTO EVERY CORNER 
                OF HOME
                </p>
                <p class="f16 light p-t-b-3vh">
                Every one of our 3- to 4-bedroom + Study units is 
                thoughtfully designed with functional spaces, smart home 
                solutions and premium fittings.
                </p>
            </div>
            <button @click="goPage('/interior')" class="home-introduce-btn" data-aos="fade-in" data-aos-duration="1000">VIEW INTERIOR</button>
            </div>
        </div>
      </div>
      <div class="CONSTRUCTION-PROGRESS">
        <div class="CONSTRUCTION-PROGRESS-title">
            <div style="margin-left: 20px;">CONSTRUCTION PROGRESS</div>
            <div style="width: 20%;text-align: start;text-indent: 1vw;">STATUS</div>
        </div>
        <div v-for="value in status" :key="value" class="CONSTRUCTION-PROGRESS-content">
            <div style="margin-left: 20px;flex: 1;">{{value.title}}</div>
            <div class="CONSTRUCTION-PROGRESS-status">
                <div v-if="value.type==1" class="status1"></div>
                <div v-if="value.type==2" class="status2"></div>
                <div v-if="value.type==0" class="status3"></div>
                <span style="margin-left: 10px;">{{ value.status }}</span>
            </div>
        </div>
        <div class="CONSTRUCTION-PROGRESS-content" style="border: 0;margin-left: 20px;">
          *Estimated date is subject to change.
        </div>
      </div>
      <contactS />
    </div>
</template>

<script>
import contactS from '@/components/contacts.vue';
import CONSTRUCTIONPROGRESS from '@/assets/data.json'

export default {
    name: 'Home',
    components: {
        contactS
    },
    data() {
        return {
            status:[]
        }
    },
    methods: {
        goPage(path) {
            this.$router.push(path);
            window.scrollTo(0, this.scrollTop)
        },
        // 滚动指定距离
        scrollTo869(){
            const targetElement = document.querySelectorAll('.home-video'); // 替换为目标元素的 ID
            if (targetElement) {
                const top = targetElement[0].offsetTop; // 获取元素距离页面顶部的偏移量
                console.log(targetElement);
                
                window.scrollTo({
                    top: top, // 滚动到的位置
                    behavior: 'smooth', // 平滑滚动效果
                });
            } else {
                console.error('目标元素未找到');
            }
        },
    },
    mounted() {
        console.log(CONSTRUCTIONPROGRESS);
        this.status = CONSTRUCTIONPROGRESS;
        
    }
}
</script>

<style lang="less" scoped>
.home {
    .pro-info{
        position: relative;
        width: 100%;
        height: 100vh;
        .text-content{
        position: absolute;
        bottom: 15%;
        left: 15%;
        z-index: 998;
        text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.705);
        p,h2{
          margin: 10px 0;
        //   width: 530px;
        }
      }
    .pro-bg{
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background-image: url('~@/assets/home/pro-bg.jpg');
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: 0 100%;
        z-index: 998;
      }
   
      .home-more-btn{
        position: absolute;
        bottom: 20px;
        left: calc(50% - 75px);
        width: 150px;
        // height: 50px;
        line-height: 14px;
        // background-color: #666b50;
        // color: white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        z-index: 998;
        img{
          width: 20px;
          height: 20px;
          object-fit: contain;
        }
      }
    }

    .home-introduce{
        &:nth-child(1){
            flex-direction: row-reverse !important;
        }
        &:nth-child(2){
            flex-direction: row;

        }
        p{
            margin: 0;
        }
        .home-introduce-btn{
            position: relative;
            width: 200px;
            height: 35px;
            line-height: 35px;
            background-color: #666b50;
            border: none;
            color: #f2ddc8;
            font-size: 14px;
            font-weight: 400;
            cursor: pointer;
        }
        .line{
            border-right: 2px solid #666b50;
            border-bottom: 2px solid #666b50;
        }
        .line1{
            border-left: 2px solid #666b50;
            border-bottom: 2px solid #666b50;

        }
    }
    .CONSTRUCTION-PROGRESS{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 100px;
        margin-bottom: 100px;
        color: #f2ddc8;
        width: 75%;
        margin: 0 auto;
        margin-top: 10vh;
        .CONSTRUCTION-PROGRESS-title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            height: 50px;
            background-color: #666b50;
            border-bottom: 1px solid #666b50;
        }
        .CONSTRUCTION-PROGRESS-content{
            display: flex;
            justify-content: center;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            // height: 50px;
            min-height: 50px;
            padding: 10px 0;
            border-bottom: 1px solid #666b50;
            text-align: start;
            font-weight: 200;
        }
        .CONSTRUCTION-PROGRESS-status{
            width: 20%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .status1{
                width: 20px;
                height: 20px;
                background-color: #f2ddc8;
                border-radius: 50%;
            }
            .status2{
                width: 5px;
                height: 5px;
                background-color: #666b50;
                border-radius: 50%;
                border: 8px solid #f2ddc8;
            }
            .status3{
                width: 20px;
                height: 20px;
                border: 1px solid #f2ddc8;
                border-radius: 50%;
            }

        }

    }

}

.phone{
    display: flex;
}

.phone-m-t-20{
    margin-top: 0;
}

@media screen and (max-width: 800px) {
    .CONSTRUCTION-PROGRESS{
        width: 90% !important;
    }
    .CONSTRUCTION-PROGRESS-status{
        width: 40% !important;
        flex-direction: column;
    }
    .CONSTRUCTION-PROGRESS-status span{
        margin-left: 0;
    }

    .phone-m-t-20{
        margin-top: 0px !important;
    }
    .p-t-b-3vh{
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .phone{
        display: none;
    }
    .pro-info{
        height: 300px !important;
        margin-top: 100px !important;
        margin-bottom: 200px;
        .pro-bg{
            background-size: auto 100% !important;
        }
        .text-content{
            left: 5% !important;
            bottom: -165px !important;
            .line-height-3-8w{
                line-height: 38px !important;
            }
            .f3-5w{
                font-size: 38px !important;
            }
            .f1-2w{
                font-size: 16px !important;
            }
        }
    }
    .h-60{
        height: 500px !important;
        .h60{
            .flex-center{
                align-items: flex-start;
            }
            .h80{
                height: 50%;
            }
        }
    }
    .w-3{
        width: 10vw;
    }
    .home-video{
        height: 250px !important;
    }
    .home-introduce{
        
        flex-direction: column !important;
        .m-l-30s{
            margin-left: 5px !important;
        }
        .h60{
            height: 65%;
        }
        .medium{
            font-weight: 400;
            }
        .line1{
            height: 250px !important;
        }
        .row-reverse{
            flex-direction: row !important;
        }
        .img-container2{
            height: 80% !important;
        }
        .w50{
            width: 100% !important;
            // height: 50% !important;
            margin: 0 auto;
            overflow: hidden;
        }
        .w400{
            .h50{
                height: 75% !important;
            }
        }
        .w500{
            width: 300px !important;
        }
        .h50{
            height: 75% !important;
        }
    }

}


</style>